export { default } from "./informationCard";
